import _ from 'lodash';
import Vue from 'vue';

class I18nMgmt {
  constructor({ langList, langPackageLoader }) {
    this._langList = langList;
    this._langPackageLoader = langPackageLoader;
  }

  init() {
    var lang = window.localStorage && window.localStorage.getItem('lang');
    if (!lang) {
      // 读取浏览器语言信息
      lang = navigator.language || navigator.userLanguage;
    }

    if (!this._langList.some(item => item.value === lang)) {
      lang = this._langList[0].value;
    }

    this._lang = lang;

    return this._langPackageLoader.load(lang).then(langPackage => {
      this._loadedLangs = [lang];
      return { lang, langPackage };
    });
  }

  setLang(i18n, lang) {
    let promise;
    if (!this._loadedLangs.includes(lang)) {
      promise = this._langPackageLoader.load(lang).then(langPackage => {
        i18n.setLocaleMessage(lang, langPackage);
        this._loadedLangs.push(lang);
      });
    } else {
      promise = Promise.resolve();
    }

    return promise.then(() => {
      Vue.config.lang = lang;
      i18n.locale = lang;

      this._lang = lang;
      let langClass;
      _.forEach(document.body.classList, item => {
        if (item.indexOf('lang-') === 0) {
          langClass = item;
          return false;
        }
      });

      document.body.classList.remove(langClass);
      document.body.classList.add(`lang-${lang}`);
      document.body.setAttribute('lang', lang);

      window.localStorage && window.localStorage.setItem('lang', lang);
    });
  }

  getLangList() {
    return this._langList;
  }

  getCurLang() {
    return this._lang;
  }
}

export default I18nMgmt;
